import React, { memo, useMemo, useState } from 'react';
import { AiOutlineEye, AiOutlineEyeInvisible } from 'react-icons/ai';
import './CommonInput.css';

const CommonInput = ({
  label,
  value,
  onChange,
  placeholder,
  error,
  secureTextEntry = false,
  multiline = false,
  leftIcon = null,
  name,
  type,
  editable = true,
  disabled = false,
}) => {
  const [isPasswordVisible, setPasswordVisible] = useState(false);
  const isPassword = secureTextEntry;
  const computedType = useMemo(() => {
    if (isPassword) {
      return isPasswordVisible ? 'text' : 'password';
    }
    if (type) return type;
    return 'text';
  }, [isPassword, isPasswordVisible, type]);

  const toggleVisibility = () => setPasswordVisible((s) => !s);

  return (
    <div className="common-input-wrapper">
      {label && <label className="common-input-label">{label}</label>}
      <div className={`common-input-field ${error ? 'error' : ''} ${disabled ? 'disabled' : ''}`}>
        {leftIcon}
        {multiline ? (
          <textarea
            name={name}
            value={value}
            onChange={(e) => onChange(e.target.value)}
            placeholder={placeholder}
            className="common-input-textarea"
            disabled={!editable || disabled}
          />
        ) : (
          <input
            name={name}
            type={computedType}
            value={value}
            onChange={(e) => onChange(e.target.value)}
            placeholder={placeholder}
            className="common-input-input"
            autoComplete={isPassword ? 'current-password' : 'on'}
            disabled={!editable || disabled}
          />
        )}
        {isPassword && !multiline && (
          <button type="button" onClick={toggleVisibility} className="common-input-icon-btn" aria-label={isPasswordVisible ? 'Hide password' : 'Show password'}>
            {isPasswordVisible ? (
              <AiOutlineEyeInvisible size={20} color="rgba(0, 0, 0, 0.5)" />
            ) : (
              <AiOutlineEye size={20} color="rgba(0, 0, 0, 0.5)" />
            )}
          </button>
        )}
      </div>
      {error ? <div className="common-input-error">{error}</div> : null}
    </div>
  );
};

export default memo(CommonInput); 